module.exports = require("babel-runtime/helpers/jsx");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/jsx"
// module id = 3
// module chunks = 0